module.exports = __webpack_public_path__ + "static/media/paw.f30524df.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/DogProfile/paw.svg
// module id = 342
// module chunks = 0